import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Import pages
import Home from 'pages/Home/Home';
import About from 'pages/About/About';
import LandingPage from 'pages/LandingPage/LandingPage';
import Chat from 'pages/Chat/Chat';
import Results from 'pages/Results/Results';

// Import authentication pages
import Login from 'pages/Login/Login';
import SignUp from 'pages/SignUp/SignUp';
import ForgotPassword from 'pages/ForgotPassword/ForgotPassword';
import ResetPassword from 'pages/ResetPassword/ResetPassword';

// Import user pages
import Profile from 'pages/Profile/Profile';

// Debug component
import DescopeDebugger from 'components/DescopeDebugger';

// Import protected route component
import ProtectedRoute from 'components/auth/ProtectedRoute';

/**
 * Main application routes component
 * Defines all public, authentication, and protected routes
 */
const AppRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        
        {/* Authentication Routes - Using Custom Design with Descope */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Debug Route - Development Only */}
        <Route path="/debug" element={<DescopeDebugger />} />
        
        {/* Protected Routes - Require Authentication */}
        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <Chat />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={<Navigate to="/" replace />}
        />
        <Route
          path="/results"
          element={
            <ProtectedRoute>
              <Results />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />

        {/* Catch-all Route - Redirect to Landing Page */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
